import { render, staticRenderFns } from "./TermsAndConditions2.vue?vue&type=template&id=44c68f6c&scoped=true"
import script from "./TermsAndConditions2.vue?vue&type=script&lang=js"
export * from "./TermsAndConditions2.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditions2.vue?vue&type=style&index=0&id=44c68f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c68f6c",
  null
  
)

export default component.exports